import { Modal, ModalHeader,ModalFooter,ModalBody } from 'reactstrap';
import React from 'react';

//<ModalHeader toggle={this.props.toggle}>{this.props.titulo}</ModalHeader>
class MensajeModal extends React.Component {
    
    render() {
        return (
            <Modal className="modal-lg" backdrop="static" isOpen={this.props.modal} toggle={this.props.toggle}>
                <ModalHeader toggle={null}>{this.props.titulo}</ModalHeader>
                <ModalBody>
                    {this.props.mensaje}
                </ModalBody>
                <ModalFooter>
                    {this.props.footer}
                </ModalFooter>
            </Modal>
    );
    }
}
export default MensajeModal;